import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../../base/Icon";
import { FontAwesomeIcons } from "../../../core/Types";
import { useScreen } from "../../../core/Global";
import SimpleBar from "simplebar-react";


export interface ISideMenuItem {
    id?: string
    name?: string
    icon?: FontAwesomeIcons
    // Brand marks (whatsapp, telegram, stripe...) only exist in the brands face, so an item
    // using one has to say so -- the default solid render comes out blank.
    iconType?: "solid" | "regular" | "light" | "thin" | "brands"
    link?: string
    seperator?: boolean
}

interface SideMenuProps {
    items: ISideMenuItem[]
    activeId?: string
}

export default function SideMenu({ items, activeId }: SideMenuProps) {

    const screen = useScreen()
    const location = useLocation()

    const isActive = (m: ISideMenuItem) => {
        if (activeId && m.id) return activeId.toLowerCase() === m.id.toLowerCase()
        if (m.link) return location.pathname.toLowerCase().startsWith(m.link.toLowerCase())
        return false
    }

    return (
        <SimpleBar className="card card-flush" style={{ height: screen.heightDoc }}>
            <div className="card-body pt-5 px-3">
                <div className="menu menu-column menu-rounded menu-state-bg menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary mb-10">
                    {
                        items.map((m, idx) => {

                            if (m.seperator) {
                                return (
                                    <div key={`sep-${idx}-${m.name}`}
                                        className="border-bottom mb-3 px-2"
                                        style={{ fontWeight: 200, fontSize: 20 }}>
                                        {m.name}
                                    </div>
                                )
                            }

                            const active = isActive(m)

                            return (
                                <div key={`menu-${m.id ?? idx}`} className="menu-item mb-3">
                                    <Link to={m.link ?? "#"} className={"menu-link" + (active ? " active" : "")}>
                                        <span className="menu-icon fs-6">
                                            <Icon icon={m.icon} type={m.iconType ?? "solid"} className={(active ? "" : " text-gray-700")} />
                                        </span>
                                        <span className={"menu-title fw-bold fs-6" + (active ? "" : " text-gray-700")}>
                                            {m.name}
                                        </span>
                                    </Link>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </SimpleBar>
    )
}
